var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login", attrs: { id: "wrap" } }, [
    _c("div", { attrs: { id: "container" } }, [
      _c("div", { staticClass: "loginBox" }, [
        _c("h1", { staticClass: "logo" }, [_vm._v("GCRM")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "txt" }, [
          _vm._v("Global Customer Relationship Marketing Portal")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-area" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary btn-lg",
              attrs: { type: "button" },
              on: { click: _vm.goToADRegist }
            },
            [_vm._v("AD " + _vm._s(_vm.$t("sdl.gcrm.common.signup")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button" },
              on: { click: _vm.loginByAd }
            },
            [_vm._v(_vm._s(_vm.$t("sdl.gcrm.common.signin")))]
          )
        ]),
        _vm._v(" "),
        _vm.knockCnt > 4
          ? _c("div", { staticClass: "afterEnter" }, [
              _c("div", { staticClass: "input_box" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userId,
                      expression: "userId"
                    }
                  ],
                  staticClass: "form-control ui--login-id",
                  attrs: {
                    type: "text",
                    id: "inputID",
                    placeholder: "ID",
                    required: "",
                    autofocus: ""
                  },
                  domProps: { value: _vm.userId },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSubmit()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.userId = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "sr-only", attrs: { for: "inputPassword" } },
                  [_vm._v("Password ")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control ui--login-pass",
                  attrs: {
                    type: "password",
                    id: "inputPassword",
                    placeholder: "Password",
                    required: ""
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-area" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.handleSubmit()
                      }
                    }
                  },
                  [_vm._v("Log in after"), _c("br"), _vm._v("entering")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "f-logo" })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tit" }, [
      _vm._v("\n        Welcome to"),
      _c("label", [_vm._v("GCRM Portal")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ccf4aac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccf4aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/LoginPage.vue
// module id = null
// module chunks = 